import { publishMessage } from "../notification/notificationActions";
import * as provinceActionTypes from "./provinceActionTypes";
import * as message from "../../message";
import { hideSpinner, showSpinner } from "../spinner/spinnerActions";
import Axios from "axios";
import { baseUrl } from "../../util/host";

export const setProvinceList = (provinces) => {
  return {
    type: provinceActionTypes.LOAD_PROVINCE,
    value: provinces,
  };
};

export const loadProvince = (country) => {
  const warehouse = localStorage.getItem("warehouse");
  const payload = { country: country, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(
      `${baseUrl("REACT_APP_API_URL")}/api/address/find/province`,
      payload
    )
      .then((res) => {
        dispatch(setProvinceList(res.data.response));
        dispatch(
          publishMessage({
            message: message.LOAD_PROVINCE_SUCCESS,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const updateProvince = (province) => {
  const country = localStorage.getItem("country");
  const warehouse = localStorage.getItem("warehouse");
  const payload = { objkey: country, country, province, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.put(`${baseUrl("REACT_APP_API_URL")}/api/address/province`, payload)
      .then((res) => {
        dispatch(
          publishMessage({
            message: message.UPDATE_PROVINCE_SUCCESS,
            severity: "success",
          })
        );
        dispatch(loadProvince(country));
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};

export const createNewProvince = (province) => {
  const country = localStorage.getItem("country");
  const warehouse = localStorage.getItem("warehouse");
  const payload = { country, province, warehouse };
  return (dispatch) => {
    dispatch(showSpinner());
    Axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/province`, payload)
      .then((res) => {
        dispatch(loadProvince(country));
        dispatch(
          publishMessage({
            message: message.CREATE_PROVINCE_SUCCESS,
            severity: "success",
          })
        );
        dispatch(hideSpinner());
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideSpinner());
      });
  };
};
